import { useGetAuthorizationsQuery } from '../services';
import { AuthorizationsFilter } from '../models';

interface UseAuthorizationsProps {
  filters?: AuthorizationsFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useAuthorizations = ({ filters, paginated }: UseAuthorizationsProps) => {
  const {
    data,
    isLoading: isAuthorizationsLoading,
    isFetching,
  } = useGetAuthorizationsQuery({ filters: filters || {}, paginated });

  return {
    authorizations: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / paginated.pageSize) : 0,
    isAuthorizationsLoading: isAuthorizationsLoading || isFetching,
  };
};

export default useAuthorizations;
